import { Component, Input } from '@angular/core';

import { DividerVariantEnum } from '~/component/divider/enums/divider-variant.enum';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
})
export class DividerComponent {
  @Input() public variant = DividerVariantEnum.Small;

  public get cssClass(): string {
    if (this.variant === DividerVariantEnum.Large) {
      return 'border-9 border-grey-light-3';
    }

    if (this.variant === DividerVariantEnum.Medium) {
      return 'border-3 border-grey-light-3';
    }

    return 'border-vtmn-play-content-brand-secondary';
  }
}
